import React from 'react';
import { Wind, RotateCw, Lock, Sparkles, Moon, Volume2 } from 'lucide-react';

export interface CustomTogglesStyle02Props {
  toggles: string[];
  values: Record<string, boolean>;
  disabled?: boolean;
  loading?: boolean;
  onChange: (name: string, value: boolean) => void;
  columns?: 2 | 3;
}

// Toggle icons
const TOGGLE_CONFIG: Record<string, { icon: React.ElementType; label: string }> = {
  AirClean: { icon: Sparkles, label: '空氣清淨' },
  AutoDirection: { icon: RotateCw, label: '自動擺動' },
  Lock: { icon: Lock, label: '鎖定' },
  Ionizer: { icon: Wind, label: '負離子' },
  Swing: { icon: RotateCw, label: '擺動' },
  Sleep: { icon: Moon, label: '睡眠模式' },
  Beep: { icon: Volume2, label: '提示音' }
};

/**
 * CustomToggles Style 02 - Horizontal Switch
 * iOS-style toggle switches with icons and labels
 */
export const Style02_HorizontalSwitch: React.FC<CustomTogglesStyle02Props> = ({
  toggles,
  values,
  disabled = false,
  loading = false,
  onChange,
  columns = 2
}) => {
  if (!toggles || toggles.length === 0) return null;

  const getToggleConfig = (toggle: string) => {
    return TOGGLE_CONFIG[toggle] || { icon: Wind, label: toggle };
  };

  return (
    <div className={`grid gap-3 ${columns === 2 ? 'grid-cols-2' : 'grid-cols-3'}`}>
      {toggles.filter(t => t !== 'Lock').map((toggle) => {
        const isOn = values?.[toggle] ?? false;
        const config = getToggleConfig(toggle);
        const Icon = config.icon;

        return (
          <div
            key={toggle}
            className="flex items-center justify-between px-3 py-2.5 bg-slate-800/30 rounded-xl border border-slate-700/30"
          >
            <div className="flex items-center gap-2">
              <Icon className={`w-4 h-4 ${isOn ? 'text-blue-400' : 'text-slate-500'}`} />
              <span className="text-xs text-slate-300">{config.label}</span>
            </div>
            
            {/* iOS-style toggle switch */}
            <button
              onClick={() => onChange(toggle, !isOn)}
              disabled={disabled || loading}
              className={`relative w-11 h-6 rounded-full transition-colors ${
                isOn ? 'bg-blue-500' : 'bg-slate-600'
              } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
            >
              <span
                className={`absolute top-0.5 left-0.5 w-5 h-5 rounded-full bg-white shadow-md transform transition-transform ${
                  isOn ? 'translate-x-5' : 'translate-x-0'
                }`}
              />
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default Style02_HorizontalSwitch;
